@import '../../global/accessibility.css';

.challenged-options {
    h3 {
        margin-top: 0;

        font-size: 16px;
    }

    ul {
        margin: 0;
        padding: 0;

        list-style: none;

        li {
            border-bottom: 1px solid $color-grey-500;
        }

        button {
            position: relative;

            display: flex;
            width: 100%;
            padding: 10px 0;
            padding-left: 30px;

            background: none;
            border: none;
            cursor: pointer;

            font-size: 1em;
            text-align: left;

            .card-icon {
                position: absolute;
                left: 0;
            }

            check-icon {
                margin-left: auto;
                margin-right: 2px;
            }
        }

        p {
            margin: 0 0 10px 30px;

            a {
                @include nj-back-link;
            }
        }
    }
}
